import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Loading } from '@domain/models/alert/loading.model';
import { Alert } from '@domainModels/alert/alert.model';
import { AlertGateway } from '@domain/models/alert/gateway/alert.gateway';
import { LoadingType } from '@domain/enums/alert/loading-type.enum';

@Injectable({
  providedIn: 'root',
})
export class AlertService extends AlertGateway {
  private _subjectAlert = new Subject<Alert>();
  private _subjectLoading = new Subject<Loading>();
  private _defaultId = 'default-alert';

  showAlert(alert: Alert): void {
    alert.id = alert.id || this._defaultId;
    alert.autoClose = alert.autoClose ?? true;
    this._subjectAlert.next(alert);
  }

  setLoading(showLoading: boolean, loadingType: LoadingType = LoadingType.Default, textsLoading: string[] = []): void {
    this._subjectLoading.next({
      showLoading,
      loadingType,
      textsLoading,
    });
  }

  onAlert(id: string): Observable<Alert> {
    return this._subjectAlert.asObservable().pipe(filter((alert) => alert && alert.id === id));
  }

  onLoading(): Observable<Loading> {
    return this._subjectLoading.asObservable();
  }

  hideAlert(id: string = this._defaultId): void {
    this._subjectAlert.next({ id });
  }
}
